import React, { useState } from "react";
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, CircularProgress, Button, Dialog,
  DialogTitle, DialogContent, DialogActions, TextField, Chip,
} from "@mui/material";
import { useGetAdminUsersQuery, useCreateUserMutation } from "state/api";
import { toast } from "react-toastify";

const UserManagement = () => {
  const { data: users, isLoading } = useGetAdminUsersQuery();
  const [createUser, { isLoading: creating }] = useCreateUserMutation();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ EmpNo: "", name: "", PASSWORD: "", MgCd: "", ACTIVE: "Y" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleCreate = async () => {
    if (!form.EmpNo || !form.name || !form.PASSWORD || !form.MgCd) {
      toast.error("All fields are required");
      return;
    }
    try {
      await createUser(form).unwrap();
      toast.success("User created!");
      setOpen(false);
      setForm({ EmpNo: "", name: "", PASSWORD: "", MgCd: "", ACTIVE: "Y" });
    } catch (err) {
      toast.error(err?.data?.message || "Failed to create user");
    }
  };

  if (isLoading) return <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}><CircularProgress /></Box>;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h5" fontWeight={700}>User Management</Typography>
        <Button variant="contained" onClick={() => setOpen(true)}>Add User</Button>
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>EmpNo</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>MgCd</TableCell>
              <TableCell>Active</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(users || []).map((u) => (
              <TableRow key={u.EmpNo}>
                <TableCell>{u.EmpNo}</TableCell>
                <TableCell>{u.name}</TableCell>
                <TableCell>{u.MgCd}</TableCell>
                <TableCell>
                  <Chip size="small" label={u.ACTIVE} color={u.ACTIVE === "Y" ? "success" : "default"} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Add New User</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
          <TextField name="EmpNo" label="Employee Number" value={form.EmpNo} onChange={handleChange} fullWidth />
          <TextField name="name" label="Full Name" value={form.name} onChange={handleChange} fullWidth />
          <TextField name="PASSWORD" label="Password" value={form.PASSWORD} onChange={handleChange} fullWidth />
          <TextField name="MgCd" label="MgCd (Role Code)" value={form.MgCd} onChange={handleChange} fullWidth
            helperText="7 chars = MR, 2-6 chars = AM, 'A' = Admin" />
          <TextField name="ACTIVE" label="Active (Y/N)" value={form.ACTIVE} onChange={handleChange} fullWidth />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleCreate} variant="contained" disabled={creating}>
            {creating ? <CircularProgress size={20} /> : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default UserManagement;
